// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"80d3e075","288":"9f73a6a4","315":"b7c2cf0b","413":"b8950cef","453":"a04ae9d0","461":"82db990a","935":"719f04b8"}[chunkId] + ".chunk.js";
};